import useBenefit from "#/components/dynamic-content/hooks/useGetBenefit"
import { useGetFundsAdministration } from "#/components/bank-details/hooks/useGetFundsAdministration"

export default function useShowBankDetails(): {
  showBankDetails: boolean
} {
  const fundsAdministration = useGetFundsAdministration()
  const benefit = useBenefit()

  return {
    showBankDetails: fundsAdministration?.data?.isBankInfoRequired && !benefit?.data?.program.isCarrotLite
  }
}
